module.exports = function () {
    $(document).ready(function (event) {

        var criminalRecord = $('.js-criminal-record'),
            medicalCondition = $('.js-medical-condition');

        if ($('input[name="criminal_record"]:checked').val() == 0) {
            criminalRecord.hide();
        } else {
            criminalRecord.show();
        }

        $('input[name="criminal_record"]').change(function () {
            if ($('input[name="criminal_record"]:checked').val() == 1) {
                criminalRecord.show();
            } else {
                criminalRecord.hide();
            }
        });

        if ($('input[name="medical_condition"]:checked').val() == 0) {
            medicalCondition.hide();
        } else {
            medicalCondition.show();
        }

        $('input[name="medical_condition"]').change(function () {
            if ($('input[name="medical_condition"]:checked').val() == 1) {
                medicalCondition.show();
            } else {
                medicalCondition.hide();
            }
        });
    });
}();
0
